import {getDataFromServer} from "../../api/request";
import {joinId} from "../../config/env";

export function sendIntent(params, startLoading = () => {
}, endLoading = () => {
}) {
    params.source = 3;
    params.joinId = joinId
    return getDataFromServer("consult/addConsult", params, startLoading, endLoading);
}
